import { ConversationalChatInactivitypromptComponent } from '@klant/conversational/conversational-chat-inactivityprompt/conversational-chat-inactivityprompt.component';

import { NgModule } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApButtonComponent } from '@ap/button';
import { ApPanelComponent } from '@ap/panel';

@NgModule({
    declarations: [ConversationalChatInactivitypromptComponent],
    exports: [ConversationalChatInactivitypromptComponent],
    imports: [ApContentPipe, ApButtonComponent, ApPanelComponent],
    providers: [ApContentService]
})
export class ConversationalChatInactivitypromptModule {}
